<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-card flat tile color="surface-variant" class="py-10 text-center">
    <v-card-text>
      <v-container>
        <h5 class="mb-5 text-body-2 font-weight-bold">Notes & Disclosure:</h5>
        <p>
          <sup>1</sup> Current taxes based on maintaining your existing Qualified Account. Qualified accounts are funded using pre-tax dollars, and taxes are generally owed on principal and interest when the funds are distributed.
        </p>
        <p>
          <sup>2</sup> Adjustment modeled is based on Roth conversion of funds. Roth accounts are funded with post-tax dollars and withdrawals of principal and interest are generally distributed tax-free. This is not a complete discussion of the benefits, limitations and requirements of Roth accounts or tax-free savings vehicles.
        </p>
        <p class="text-caption font-italic">
          This analysis is designed to provide general information only. Pursuant to IRS Circular 230 and any license limitations of the licensed professional presenting this material, this analysis is not intended to provide tax or legal advice. Be sure to speak with a qualified professional in these areas before making any decisions about your personal situation. This analysis does not consider every product or feature of tax-deferred or Roth accounts and is for illustrative purposes only. It should not be deemed a representation of past or future results, and is no guarantee of return or future performance. Your tax bracket may be lower or higher in retirement, unlike this hypothetical example. Every effort has been made to ensure the accuracy of these numbers. RMD calculation data gathered from Stonewood RMD calculation software based on IRS guidelines and tables, and is hypothetical only. Your actual RMDs are determined by a variety of factors.
        </p>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="text-caption font-italic text-on-surface-variant" v-html="store.company.lead_capture_disclosure" />
        <p class="text-caption font-italic">
          By submitting your contact information, you consent to be contacted by a Financial Professional regarding retirement income strategies.
        </p>
        <p class="text-center mt-5">
          &copy;{{ new Date().getFullYear() }} All rights reserved.
        </p>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useLeadGeneratorStore } from '@/stores/leadGenerator'
const store = useLeadGeneratorStore()
</script>
